export default {
  // 文件库
  Navigation: {
    retract: 'Retract the navigation',
    opennav: 'Open the navigation',
    app: 'Application',
    workbench: 'Worbench',
    complete: 'Complete',
    commonly: 'Commonly set',
    myCommonly: 'Yy common',
    appDragApp: 'Frag sort,up to 8 can be added',
    system: 'System module',
    cApp: "Organization's application",
    goAdd: 'Go to add',
    editPwd: 'Edit password',
    determine: 'Determine',
    cancel: 'Cancel',
    mail: 'Unread mail',
    allRead: 'All read',
    viewAll: 'View all',
    notification: 'Notification',
    help: 'Help document',
    suggest: 'Suggest feedback',
    viode: 'Video tutotial',
    guide: 'Guide',
    preferences: 'Preferences',
    personal: 'Personal setting',
    gobackend: 'System setting',
    exit: 'Exit',
    selectColor: 'Select colors',
    customColors: 'Custom colors',
    Tips: 'Tips',
    Dear: 'Dear user',
    Expire1: 'Use time is about to expire, expiration time',
    Expire2: 'Please contact the staff of platform OPS immediately',
    repeatAddition: 'Custom colors are added repeatedly',
    quickAdd: 'Quickly add',
    switchcompanies: 'Switching',
    myapp: 'My app',
    createapplication: 'Create application',
    helpcenter: 'Help center',
    mobileterminaluse: 'Mobile terminal',
    helpdocument: 'Help documentation',
    technicalsupport: 'technical support',
    applicationcenter: 'Application Center',
    updatelog: 'Update log',
    requirementsfeedback: 'Demand feedback',
    productevaluation: 'Product evaluation',
    turnonlevitationbutton: 'Turn on the hover button',
    layoutsettings: 'Layout settings',
    skinsettings: 'Skin settings',
    selectskin: 'Choose skin',
    custom: 'custom',
    selectskinTip: 'It is recommended to use 1920 * 1024 size pictures',
    teamfacegivesyoumoreoptions: 'Gives you more choices',
    youcanuseteamfaceonmobileinthefollowingway:
      'You can use on the mobile end in the following ways',
    teamfacewechatservicenumber: 'Wechat service number',
    scancodetofollowTip: 'Scan code attention official account in WeChat using system',
    scancodetofollowTip2: 'Pay attention to the public number login system',
    integrationintothirdpartyapp: 'Application to third party integration',
    applyfortrial: 'Apply for probation',
    toconsultcustomerservice: 'Scanning code consulting wechat customer service',
    callforinformation: 'Consultation telephone',
    needanothermobilesolutio: 'Need other mobile solutions? Please click to let us know',
    renewalalert: 'Renewal reminder',
    dearuseryourservicehasexpire:
      'Dear user, your service has expired. If you need to continue to use, please renew it in time or call us for consultation. You can use it normally after renewal.',
    totalsystemquantitytotalspace: 'Total number of systems / total space',
    upto90: 'Up to 90%',
    rechargeassoonaspossibleTip:
      'Please recharge as soon as possible to avoid the failure to create and save business data due to insufficient quantity',
    pay: 'pay',
    yuandelayedbyoneday: 'One day delay',
    renewimmediatelyperyear: 'Immediate renewal (per year)',
    selectlayout: 'Select layout',
    selectpopover: 'Select pop-up window',
    renewalperiod: 'Renewal period',
    platformmessages: 'Platform news',
    upgradealert: 'Upgrade reminder',
    laterversion: 'Updated version',
    updatecontent: 'Update content',
    isee: 'I got it',
    sideshot: 'sidearm',
    popover: 'popup',
    fullscreenpopover: 'Full screen pop-up window',
    classicnavigation: 'Classic navigation',
    simplenavigation: 'Simple navigation',
    traditionalnavigation: 'Traditional navigation',
    traditionalfunctional: 'Traditional functional',
    sidebarnavigation: 'Sidebar navigation',
    sidebarfunctional: 'Sidebar functional',
    customerexpirationdate: 'Customer usage time expired',
    backofficemanagement: 'back-stage management',
    workbenchmanage: 'Portal Management',
    approvalmanage: 'Examination and approval management',
    projectmanage: 'project management',
    emailmanage: 'Mail management',
    reportmanage: 'Data report',
    attendancemanage: 'Attendance management',
    salarymanage: 'Salary management',
    repositorymanage: 'Knowledge base management',
    filelibrarymanage: 'File base management',
    appmanage: 'Application management',
    num1: 'a111',
    selectcompanyindustry: "Choose the organization's industry",
    industryofthecompany: 'Industry of the organization',
    selectsystemtouse: 'Choose to use the system',
    nextstep: 'next step',
    gotoappmarket: 'Go to the app market',
    seemoreapps: 'See more apps',
    backup: 'last step',
    nofindasuitableapplicatio: 'No suitable application found? Come on',
    createmanually: 'Create manually',
    bar: 'bar',
    clicktousetheapp: 'Click to enter the app',
    oneclicktoinstallanduseapps: 'Click one button to install and use the app',
    totalrequirementsgathering: 'All requirements collection',
    newdata: 'New data',
    moreoperations: 'More operations',
    batchimportdata: 'batch import data',
    step1: '1 / 3 module list header operation',
    step2: '2 / 3 module list title bar operation',
    step3: '3/3 add submenu actions',
    customerowner: 'customer owner',
    customername: 'customer name ',
    totalnumber: 'headcount',
    industry: 'Industry',
    checkthefieldsyouwanttodisplay: 'Check the fields you want to display',
    moveinandclickanddragcolumnwidth: 'Move in click drag column width',
    administratorcansavedraggedcolumnwidth: 'The administrator can save the dragged column width',
    clickautosort: 'Click auto sort',
    setlistdisplayfield: 'Set list display fields',
    filterlistdata: 'Filter list data',
    addsubmenu: 'Add submenu',
    addedsubmenu: 'Added submenu',
    whaticareabout: 'What I care about',
    addenterpriseapplications: 'Add enterprise app',
    enterpriseapplicationcenter: 'Enterprise Application Center',
    alltradesandoccupationsreadytouse: 'All walks of life are ready to use',
    createblankapplication: 'Create a blank app',
    buildwhateveryouwant: 'Build at will',
    enterprisecustomization: 'Enterprise private customization',
    professionalconsultantscustomised: 'Personalized customization of professional consultants',
    underinstallation: 'Installing',
    customerrelationshipmanagement: 'customer relationship management',
    hrhumanresourcesystem: 'HR system',
    srmsupplierrelationshipmanagementsystem: 'SRM supplier relationship management system',
    invoicingmanagement: 'inventory management',
    environmentalengineering: 'environmental protection engineering',
    propertymanagementsystem: 'property management system',
    batchmodification: 'batch modification',
    founder: 'founder',
    createtime: 'creation time',
    ordernumber: 'order number',
    department: 'department',
    belongingnumber: 'belonging number',
    contractname: 'contract name',
    contractnumber: 'contract number',
    contractpartya: 'Party A of the contract',
    personinchargeofpartya: 'Person in charge of Party A',
    companyindustry_empty: 'The industry of the organization cannot be blank',
    systemtouse_empty: 'Please choose to use the system',
    scan_download: 'Code scanning download',
    also: 'Just so so',
    appapply: 'Appapply',
    complaintsSuggestions: 'Complaints Suggestions',
    EnterpriseBackgroundSetting: 'System background Settings',
    AppNav: 'Application of the navigation',
    mouseDragSort: 'Hold down the mouse, delay can adjust the order',
    noResultsReceived: 'No results have been received',
    appSetting: 'Application Settings',
    portalSetting: 'The portal Settings',
    KnowledgeSetting: 'Knowledge base Settings',
    librarySetting: 'File library Settings'
  }
}
